export default {
    privacy: {
        title: 'Privacy Policy',
        text: `
        <div class="block-text">

        <p>
        <strong>NKCV</strong> uses cookies for functional and analytical purposes. Cookies are small, locally stored, files that websites use to track information about users. For more information about cookies, please visit: <a href="https://cookiesandyou.com/" target="_blank" rel="noopener">https://cookiesandyou.com</a>.
        </p> <br>

        <p>
        The main purpose of cookies placed by our website is to track user experience throughout the website. We save data about how users navigate the website, but are strict to never collect personally identifiable data. This means we don’t collect data like exact locations, ip-addresses and keystrokes. We collect the minimum amount of data required for our purposes and will never sell any of it to third parties. We do not use cookies to retarget, remarket or identify users in any way.
        </p> <br>

        <p>
        To effectively and safely process data collected we work with one data-processors (Google). Google is restricted from processing data without explicit request and prohibited from becoming a controller and processing and sharing the data any further, outlined in our Data Processing Agreement.
        </p> <br>

        <p>
        Our partner in the web area, both in construction and data collection, is OWOW (<a href="https://owow.agency/" target="_blank" rel="noopener">https://owow.agency</a>) an agency based in Eindhoven. We collaborate to build a data stream that collects and processes important data efficiently and safely for us.
        </p> <br>

        </div>
        `,
    },
    disclaimer: {
        title: 'Disclaimer',
        text: `
        Het NKCV heeft deze test in samenwerking met <a href="http://www.einfach.com/" target="_blank">Einfach</a> ontwikkeld.
        <br><br>
        De test is gebaseerd op wetenschappelijke kennis en klinische ervaring. Er wordt uitdrukkelijk geen diagnose gesteld of medisch advies gegeven.
        <br><br>
        Hoewel aan alle pagina's van de vermoeidheidstest de grootst mogelijke zorg is besteed, kunnen er geen rechten aan worden ontleend.
        <br><br>
        Het NKCV of Einfach aanvaardt geen enkele aansprakelijkheid die zou kunnen voortvloeien uit de inhoud van de pagina's van de vermoeidheidstest.
        <br><br>
        Wanneer je gezondheidsklachten hebt raden wij je te allen tijde aan contact op te nemen met je huisarts (of eventueel je specialist).
        <br><br>
        De informatie op deze site is in geen enkel geval een vervanging van de informatie die door een arts wordt verstrekt.
        <br><br>
        Het NKCV en Einfach zijn niet verantwoordelijk voor de inhoud van de pagina's van derden waarnaar de vermoeidheidstest linkt.
        <br><br>
        Namen en ervaringen van mensen die je op deze site aantreft zijn gefingeerd. Zij geven een waarheidsgetrouwe weergave van de klinische werkelijkheid.
        `,
    },
};
